<div class="cursor-pointer position-relative notification-icon-container p-1" style="margin-top: -3px" (click)="toggleNotification()">
    <mat-icon style="vertical-align: middle; color: #B1B1B1" >notifications </mat-icon> 
    <div class="rounded-circle position-absolute notification-count" *ngIf="notificationData.length != 0" ></div>
</div>

<!-- 
<ng-template
  cdkConnectedOverlay
  [cdkConnectedOverlayOrigin]="trigger"
  [cdkConnectedOverlayHasBackdrop]="true"
  (backdropClick)="displayContainer = false"
  backdropClass="transparent-backdrop"
  [cdkConnectedOverlayOpen]="displayContainer"
  [cdkConnectedOverlayPositions]="positions"
  [cdkConnectedOverlayPush]="true">
  <div class="notification-background  pt-3 pb-4 rounded">
    <div class="row px-3">
      <div class="col-sm-12">
        <label class="fs-7 fw-semibold">Notifications</label>
      </div>
    </div>
    <div class="notification-list pe-0 ">
        <ng-container *ngIf="notificationData.length === 0">
            <div class="row px-3 " >
                <div class="col-sm-12 text-center">
                    <label class="fs-10">No notifications..</label>
                    
                </div>
            </div>
        </ng-container>
        <ng-container *ngIf="notificationData.length !== 0">
            <div class="row px-3 py-2 my-1 notification cursor-pointer" *ngFor="let data of notificationData" (click)="redirectNotification(data)">
                <div class="col-sm-1 pe-0">
                    <i class="pi pi-file" ></i>
                </div>
                <div class="col-sm-9 ps-0">
                    <label class="cursor-pointer ps-2" [innerHTML]="data?.message"></label>
                </div>
                <div class="col-sm-2 text-gray-400">
                    <span class="timestamp">{{data?.timestamp | notificationDate}}</span>
                </div>
            </div>
            <div class="row px-3 mt-2  mb-0 pb-0 text-center">
                <label class="text-gray-600">END</label>
            </div>
        </ng-container>
    </div>
  </div>
</ng-template> -->